<button type="button" class="dialog-btn-close" (click)="closeModal()"></button>
<mat-dialog-content>
  <div class="confirm-dialog">
    <div class="confirm-icon" [class]="'confirm-icon-' + type">
      <mat-icon>{{ icon }}</mat-icon>
    </div>

    <h4 class="confirm-title">{{ data.title }}</h4>
    <p class="confirm-message">{{ data.message }}</p>

    <ng-container *ngIf="data.remarks_box">
      <mat-form-field class="w-100 confirm-remarks" [formGroup]="formGroup" appearance="outline">
        <textarea
          matInput
          rows="3"
          formControlName="remarks"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'remarks')"
          placeholder="Type your remarks here..."
        ></textarea>
        @if (!Global.isInputRuleValid(formGroup, 'remarks', 'required')) {
        <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </ng-container>

    <div class="confirm-actions">
      <button
        mat-stroked-button
        class="confirm-btn confirm-btn-cancel"
        (click)="onCancel()"
      >
        {{ data.cancelText }}
      </button>
      <button
        mat-flat-button
        [class]="'confirm-btn confirm-btn-save confirm-btn-' + type"
        (click)="onConfirm()"
      >
        {{ data.saveText }}
      </button>
    </div>
  </div>
</mat-dialog-content>
